import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import TableSorter from "../../common/components/TableSorter";

export const TablePage = ({ loading, reusableCachePage, onAddAll, onSelectionChange, handleSortChange, currentOrderBy, changeModalView, savePg }) => {
    const [selectedIds, setSelectedIds] = useState([]);
    const [isAdding, setIsAdding] = useState(false);

    useEffect(() => {
        setSelectedIds([]);
    }, [reusableCachePage]);

    useEffect(() => {
        if (typeof onSelectionChange === "function") onSelectionChange(selectedIds);
    }, [selectedIds, onSelectionChange]);

    if (loading) {
        return (
            <LoadingSpinner
                style={{ margin: "80px auto", position: "relative", top: "unset" }}
            />
        );
    }

    const toggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };



    const Cell = ({ children, title, style }) => (
        <td
            title={title}
            style={{
                verticalAlign: "top",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 220,
                ...style,
            }}
        >
            {children}
        </td>
    );
    const SortableHeader = ({ label, sortKey, width }) => (
        <th style={{ width }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <h4 style={{ margin: 0 }}>{label}</h4>
                {sortKey ? (
                    <TableSorter
                        name={sortKey}
                        handleSortChange={handleSortChange}
                        currentOrderBy={currentOrderBy}
                    />
                ) : null}
            </div>
        </th>
    );
    return (
        <div>
            {typeof onAddAll === "function" && (
                <div style={{ marginBottom: 16, textAlign: "right" }}>
                    <button
                        type="button"
                        className="button-secondary"
                        onClick={handleAddAll}
                        disabled={disabled}
                        style={{
                            opacity: disabled ? 0.5 : 1,
                            cursor: disabled ? "not-allowed" : "pointer",
                        }}
                    >
                        {isAdding ? "Adding..." : "Add All"}
                    </button>
                </div>
            )}


            <div style={{ overflowX: "auto" }}>
                <table
                    style={{ overflow: "initial", padding: 0, tableLayout: "fixed", width: "100%" }}
                    className="table study cache-page"
                >
                    <tbody>
                        <tr style={{
                            paddingLeft: "32px",
                            borderRadius: 8,
                            boxShadow: "rgb(255 255 255) -16px 0px 0px inset",
                        }}>
                            <th style={{ width: 80 }}>Select</th>
                            <SortableHeader label="Id" sortKey="id" width={80} />
                            <SortableHeader label="Name" sortKey="name" width={200} />

                            <SortableHeader label="Language" sortKey="language" width={120} />
                            <SortableHeader label="Location" sortKey="location" width={120} />
                            <SortableHeader label="Device" sortKey="device" width={100} />

                            <SortableHeader label="Created" sortKey="created" width={110} />
                            <SortableHeader label="Published" sortKey="article_published_date" width={110} />
                            <SortableHeader label="Last Used" sortKey="last_time_used" width={110} />

                            <SortableHeader label="Used Count" sortKey="used_count" width={110} />

                            <SortableHeader label="Tag Type" sortKey="tagtype" width={110} />
                            <th style={{ width: 200 }}>Tags</th>

                            <th style={{ width: 150 }}>Original Page</th>
                            <th style={{ width: 170 }}>Reusable Cache Page</th>
                        </tr>

                        {reusableCachePage.map((item) => {
                            const rowId = Number(item.cachepageid ?? item.id);
                            const tags = Array.isArray(item.tags) ? item.tags.filter(Boolean) : [];

                            return (
                                <tr key={rowId}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                appearance: "checkbox",
                                                display: "inline-block",
                                                visibility: "visible",
                                            }}
                                            checked={selectedIds.includes(rowId)}
                                            onChange={() => toggleSelect(rowId)}
                                        />
                                    </td>

                                    <Cell title={`${rowId}`}>{rowId}</Cell>
                                    <Cell title={item.name} style={{ maxWidth: 260 }}>
                                        {item.name}
                                    </Cell>

                                    <Cell title={item.language}>{item.language || "-"}</Cell>
                                    <Cell title={item.location}>{item.location || "-"}</Cell>
                                    <Cell title={item.device}>{item.device || "-"}</Cell>

                                    <Cell title={item.created}>
                                        {item.created || "-"}
                                    </Cell>

                                    <Cell title={item.article_published_date}>
                                        {item.article_published_date || "-"}
                                    </Cell>

                                    <Cell title={item.used_last_datetime}>
                                        {item.used_last_datetime || "-"}
                                    </Cell>

                                    <Cell title={`${item.count ?? ""}`}>{item.count ?? "-"}</Cell>

                                    <Cell title={item.tag_type}>{item.tag_type || "-"}</Cell>

                                    <td
                                        title={tags.join(", ")}
                                        style={{
                                            verticalAlign: "top",
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            maxWidth: 320,
                                        }}
                                    >
                                        {tags.length ? tags.join(", ") : "-"}
                                    </td>

                                    <Cell>
                                        {item.original_source ? (
                                            <a target="_blank" rel="noopener noreferrer" href={item.original_source}>
                                                Original Link
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </Cell>

                                    <Cell>
                                        {item.cached_source ? (
                                            <a target="_blank" rel="noopener noreferrer" href={item.cached_source}>
                                                Cached Link
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </Cell>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};